import { EventNames } from '@farmasiet/frontendcore-reactcomponents';

export interface ISearchEvent {
    phrase: string;
}

export function clearSearchInput() {
    window.dispatchEvent(new CustomEvent(EventNames.ResetSearch));
}
